import { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

function useTrackViewing(threshold, timeoutInMillis, trackInView, trackViewed) {
    const [ref, inView] = useInView({ threshold });
    const [trackViewedTimeoutId, setTrackViewedTimeoutId] = useState(undefined);

    useEffect(() => {
        let timeoutId;
        if (inView) {
            trackInView();
            if (trackViewedTimeoutId === undefined) {
                timeoutId = setTimeout(trackViewed, timeoutInMillis); // assumes trackViewed callback will still be valid when timeout occurs
                setTrackViewedTimeoutId(timeoutId);
            }
        } else if (trackViewedTimeoutId !== undefined) {
            clearTimeout(trackViewedTimeoutId);
            setTrackViewedTimeoutId(undefined);
        }

        return () => {
            // Clear timeout on unmount
            clearTimeout(timeoutId);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inView, timeoutInMillis]); // Only re-run effect on inView changes, and if timeoutInMillis is updated

    return [ref, inView];
}

export default useTrackViewing;
